import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { ipTrace } from "@forproxyband/react-tools";
import { Box } from "@mui/material";

import { getTraceroute } from "../../../utils/helpers";
import { collectServerSideState } from "../../../utils/helpers/collectServerSideState";

import { useToolsScan } from "../../../hooks";

import { BoxWrapper, Container, Input, ProgressBar } from "../../../components";
import { Seo } from "../../../components/Seo/Seo";
import { Faq } from "../../../components/common/Faq/Faq";
import HeadUpperSeo from "../../../components/common/HeadUpperSeo";
import Spinner from "../../../components/common/Spinner";
import { Button } from "../../../components/ui/Button/Button";
import { Divider } from "../../../components/ui/Divider/Divider";

import { Section } from "../../../components/common/Section/Section.styled";
import {
  ButtonWrapper,
  InputWrapper,
  ProgressBarWrapper,
  ProgressText,
  ResultText,
  ResultWrapper,
  Wrapper,
} from "./IpTracing.styled";

const IpTracing = () => {
  const [traceResult, setTraceResult] = useState(null);
  const { inputValue, setInputValue, showLoader, setShowLoader } =
    useToolsScan();

  const { t } = useTranslation();

  const loaderCallback = res => {
    setShowLoader(res);
  };
  const errorMessage = () => toast.error(t("global.error"));
  const incorrectIpOrDomenMessage = () => toast.error(t("traceIp.incorrectIp"));

  const setterTraceCallback = res => {
    setTraceResult(res);
  };

  const handleChange = e => {
    const { value } = e.target;

    setInputValue(value);
  };

  const submitHandler = async e => {
    e.preventDefault();
    setTraceResult(null);

    if (inputValue.trim() === "") {
      return toast.error(t("traceIp.incorrectIp"));
    }

    await ipTrace.trace(
      inputValue.trim(),
      false,
      setterTraceCallback,
      loaderCallback,
      errorMessage,
      incorrectIpOrDomenMessage,
    );
  };

  return (
    <>
      <Section variant="start">
        <Container>
          <HeadUpperSeo />

          <BoxWrapper>
            <Box component="form" mb={3}>
              <Wrapper>
                <InputWrapper>
                  <Input
                    onChange={handleChange}
                    className="grey"
                    fullWidth
                    placeholder={t("traceIp.inputPlaceholder")}
                  />
                </InputWrapper>

                <ButtonWrapper>
                  <Button
                    type="submit"
                    fullWidth
                    disable={showLoader}
                    onClick={submitHandler}
                  >
                    {showLoader ? (
                      <Spinner text={t("traceIp.traceButton")} />
                    ) : (
                      t("traceIp.traceButton")
                    )}
                  </Button>
                </ButtonWrapper>
              </Wrapper>
            </Box>
            <Divider />

            <ProgressBarWrapper>
              {(showLoader || traceResult) && (
                <ProgressText>{t("traceIp.status")}:</ProgressText>
              )}
              {showLoader && <ProgressBar />}
            </ProgressBarWrapper>

            {traceResult && (
              <ResultWrapper>
                <ResultText>{getTraceroute(traceResult)}</ResultText>
              </ResultWrapper>
            )}
          </BoxWrapper>
        </Container>
      </Section>

      <Faq sectionType="innerTools" />
      <Seo sectionType="innerTools" />
    </>
  );
};

IpTracing.getServerSideState = async (store, params) => {
  await collectServerSideState(store, params);
};

export default IpTracing;
